import Vue from 'vue';
import VueRouter, { NavigationGuard, Route } from 'vue-router';
import SplashScreen from '@/components/screens/SplashScreen.vue';
import SearchContainer from '@/components/screens/SearchContainer.vue';
import FavouritesScreen from '@/components/screens/FavouritesScreen.vue';
import ModulesScreen from '@/components/screens/ModulesScreen.vue';
import { Component } from 'vue-property-decorator';
import NotFoundScreen from '@/components/screens/NotFoundScreen.vue';
import { globalViewModel } from '@/container';

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: SplashScreen,
    },
    {
        path: '/search',
        name: 'search',
        component: SearchContainer,
        meta: {
            asyncScroll: true,
        },
    },
    {
        path: '/favourites',
        name: 'favourites',
        component: FavouritesScreen,
        meta: {
            asyncScroll: true,
        },
    },
    {
        path: '/lists',
        name: 'lists',
        component: ModulesScreen,
    },
    {
        path: '/gloss/:id/:category_id?',
        name: 'gloss-details',
        component: SearchContainer,
    },
    {
        path: '*',
        name: 'not-found',
        component: NotFoundScreen,
    },
];

let verifiedSessionAlive = false;

function cacheRoute(route: Route): void {
    const { name, params, query } = route;
    const cachedRoute = { name, params, query };
    localStorage.setItem('ow_cached_route', JSON.stringify(cachedRoute));
}

const authGuard: NavigationGuard = (to, from, next) => {
    if (!verifiedSessionAlive) {
        globalViewModel.verifiedUser.subscribe(user => {
            if (!user) {
                const hslFlag = document.cookie.replace(/(?:^|.*;\s*)HSL-FLAG\s*=\s*([^;]*).*$|^.*$/, '$1');
                if (hslFlag === 'true') {
                    globalViewModel.beginUserLogin();
                    return;
                }
            }
            verifiedSessionAlive = true;
            next();
        });
    } else {
        next();
    }
};

const scrollBehavior = function(to: Route, from: Route, savedPosition: any) {
    if (savedPosition) {
        if (to.matched.some(m => m.meta.asyncScroll)) {
            return new Promise(resolve => {
                // @ts-ignore
                this.app.$root.$once('readyToScroll', () => {
                    setTimeout(() => {
                        resolve(savedPosition);
                    }, 200);
                });
            });
        }
        return savedPosition;
    } else {
        return { x: 0, y: 0 };
    }
};

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior,
});

router.beforeEach(authGuard);

export default router;
